'use client';

import Badge from '@mui/material/Badge';
import TabComponent from '@mui/material/Tab';
import { PropsWithChildren } from 'react';

import { useLinkComponent } from '../index';

export interface Props {
	href: string;
	error?: boolean;
}

const Tab = ({ href, error, children }: PropsWithChildren<Props>) => {
	const LinkComponent = useLinkComponent();

	return (
		<TabComponent
			LinkComponent={LinkComponent}
			href={href}
			label={
				<Badge color="error" variant="dot" invisible={!error}>
					{children}
				</Badge>
			}
		/>
	);
};

export default Tab;
